export const constructUser = (obj: UserObj): User => {
    function generateUserName(userObj: UserObj) {
        if (obj) {
            const { firstName, lastName, user_name, username, userId } = userObj;

            if (lastName && firstName) {
                return `${lastName}, ${firstName}`;
            }
            if (lastName || firstName) {
                return lastName || firstName;
            }

            return user_name || username || userId;
        }

        return '';
    }

    return obj
        ? {
              emailVerified: obj.email_verified,
              email: obj.email,
              username: generateUserName(obj),
              roles: obj.roles.split(','),
              groups: obj.groups,
              tenantKey: obj.tenantKey,
              customerId: obj.customerId,
              // this parameter helps us find matching users between mcconnect/okta and GET/users response
              userId: obj.userId,
              firstName: obj.firstName,
              lastName: obj.lastName,
              landlordId: obj.landlordId,
              tableauToken: obj.tableauToken
          }
        : {
              email: '',
              emailVerified: false,
              username: '',
              roles: [],
              groups: '',
              tenantKey: '',
              customerId: '',
              landlordId: '',
              userId: '',
              firstName: '',
              lastName: '',
              tableauToken: ''
          };
};

// This function looks for the matching user to the user passed into the function from DB
// if found, returns the username formatted based on the DB user information
// otherwise, returns the original username
// if a specific username to return was passed to the function, return that username instead
export const getCustomUserName = (userNameToSearch: string, users?: UsersHashmap, userNameToReturn?: string) => {
    return users?.[userNameToSearch]?.username ?? userNameToReturn ?? userNameToSearch;
};
